import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import {
  isMobile,
  NumPad,
  useTranslation,
  notificationStore,
  useInputValueChangingFunctions,
} from '@pascal/pascal-core';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import BetSection from '../betSection';
import RangeSection from '../rangeSection';
import BetInfoSection from '../betInfoSection';
import UnderOverSection from '../underOverSection';
import { doBetStore, gameStore } from '../../../store';
import { betAmountValidator } from '../../../helpers/supporters';
import { useClickOutside } from '../../../hooks';
import { NumPadWr } from '../../../containers/mobile/numPadWr/numPad';

let mobileWrRef;

const GameMainBottomSection = observer(() => {
  const t = useTranslation();
  const { limits } = gameConfigStore;
  const {
    margin,
    isBetsClosed,
    numPadData: { isOpen },
  } = gameStore;

  const {
    marketType,
    rangeNumber,
    setBetAmount,
    setMarketType,
    setRangeNumber,
    totalBetsAmount,
    isLoadingBetButton,
    betData: { amount, isDisabled },
  } = doBetStore;

  const [numPudInputValue, updateNumPudInputValue] = useState(limits.minBet);

  const [ref, hasClickedOutside] = useClickOutside();

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    changingValue: amount,
    changingValueCallback: setBetAmount,
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
  });

  const handleInputBlur = (betAmount) => betAmountValidator(betAmount, gameConfigStore.limits);

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  useEffect(() => {
    if (hasClickedOutside) {
      gameStore.setNumPadData({ isOpen: false, currentInputValue: null });
    }
  }, [hasClickedOutside]);

  const validatedNumPudInputValue = (callback) => {
    const { validatedBetAmount, errorMessageCode } = handleInputBlur(numPudInputValue);
    if (errorMessageCode) {
      notificationStore.setNotificationType({ responseCode: errorMessageCode });
    }
    callback(validatedBetAmount);
  };

  const handleSubmit = useCallback(
    (isConfirmed) => {
      if (isConfirmed) {
        validatedNumPudInputValue(doBetStore.setBetAmount);
        gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
      }
    },
    [numPudInputValue]
  );

  const handleOpenNumPad = (event) => {
    if (isMobile()) {
      updateNumPudInputValue(event.target.value);
      gameStore.setNumPadData({
        isOpen: true,
        currentInputValue: event.target.value,
      });
    }
  };

  return (
    <>
      <div className='monti-bet-side'>
        <div className='monti-bet'>
          <div className='monti-bet-actions'>
            <BetInfoSection
              t={t}
              marketType={marketType}
              rangeNumber={rangeNumber}
              amount={amount}
            />
            <div className='monti-bet-content'>
              <RangeSection
                margin={margin}
                marketType={marketType}
                rangeNumber={rangeNumber}
                isBetsClosed={isBetsClosed}
                setRangeNumber={setRangeNumber}
              />
              <UnderOverSection t={t} marketType={marketType} setMarketType={setMarketType} />
              <BetSection
                t={t}
                limits={limits}
                betAmount={amount}
                onChange={setBetAmount}
                isDisabled={isDisabled}
                onBlur={handleInputBlur}
                isBetsClosed={isBetsClosed}
                totalBetsAmount={totalBetsAmount}
                handleOpenNumPad={handleOpenNumPad}
                isLoadingBetButton={isLoadingBetButton}
                handleChangeInputValue={handleChangeInputValue}
                showNotification={notificationStore.setNotificationType}
              />
            </div>
          </div>
        </div>
      </div>
      <NumPadWr containerRef={mobileWrRef}>
        <div ref={ref} className={`numpad-wr-for-outside-click ${isOpen ? 'active' : ''}`}>
          <NumPad
            t={t}
            isOpen={isOpen}
            limits={limits}
            onSubmit={handleSubmit}
            amountValue={numPudInputValue}
            setAmountValue={updateNumPudInputValue}
          />
        </div>
      </NumPadWr>
    </>
  );
});

export default GameMainBottomSection;
